import classNames from "classnames";
import { FC, ReactNode } from "react";
import SvgCheck from "../icons/CheckIcon";
import SvgError from "../icons/Error";
import SvgInfo from "../icons/Info";
import SvgWarning from "../icons/Warning";
import styles from "./Boxes.module.css";
import Icon from "./Icon";

interface Props {
  text: string | ReactNode;
  className?: string;
}

type Variant = "success" | "info" | "warning" | "error";

const ICONS: Record<Variant, typeof SvgCheck> = {
  success: SvgCheck,
  info: SvgInfo,
  warning: SvgWarning,
  error: SvgError,
};

const Box: FC<Props & { variant: Variant }> = ({ text, className, variant }) => (
  <span className={classNames(styles.text, styles[variant], className)}>
    <Icon glyph={ICONS[variant]} className={styles.icon} /> {text}
  </span>
);

export const SuccessBox: FC<Props> = (props) => <Box {...props} variant="success" />;
export const InfoBox: FC<Props> = (props) => <Box {...props} variant="info" />;
export const WarningBox: FC<Props> = (props) => <Box {...props} variant="warning" />;
export const ErrorBox: FC<Props> = (props) => <Box {...props} variant="error" />;
